import React from 'react';

import { Link, Paper, Stack, Typography } from '@mui/material';

export const SaleDetails = ({ sale_detais, description, token_name }) => {
  return (
    <Paper
      sx={{
        borderRadius: 10,
        boxShadow: '0 2px 4px -2px rgba(0,0,0,0.24), 0 4px 24px -2px rgba(0, 0, 0, 0.2)',
        p: { md: 2, sm: 2, xs: 2 }
      }}
      elevation={9}>
      <Typography variant="h6" gutterBottom component="div">
        {`About ${token_name}`}
      </Typography>
      <Typography variant="body2" gutterBottom>
        {` ${description}`}
      </Typography>
      {sale_detais.length > 0 && (
        <>
          <Typography variant="h6" gutterBottom component="div">
            {`Sale Details`}
          </Typography>

          {sale_detais.map((sale_item, index) => (
            <Stack key={index} direction="row">
              <Link
                href={sale_item.details_link}
                underline="hover"
                target="_blank"
                rel="noopener"
                key={index}>
                {'Details'}
              </Link>

              <Typography
                key={sale_item.sale_detais_tex}
                variant="body2"
                gutterBottom
                textAlign="center"
                sx={{ mr: 2 }}>
                {` : ${sale_item.sale_details_text}`}
              </Typography>
            </Stack>
          ))}
          <Typography
            variant="body2"
            gutterBottom
            sx={{ mr: 2 }}
            style={{ whiteSpace: 'pre-line' }}>
            {sale_detais.sale_detais_text}
          </Typography>
        </>
      )}
    </Paper>
  );
};
